<template>
  <b-container>
    <!-- confirm modal -->
    <b-modal
      id="confirm-user"
      ref="confirm-user"
      title="You will lose access immediately, do you wish to proceed or cancel?"
      size="lg"
      hide-footer
    >
      <b-form @submit="confirmUserModalSubmit">
        <b-button type="submit" variant="danger" class="mb-2">Yes</b-button>

        <b-button variant="success" class="mb-2 ml-2" @click="$bvModal.hide('confirm-user')">No</b-button>
      </b-form>
    </b-modal>

    <div class="payment-container">
      <div class="cancel-confirmation" v-show="confirmCancel">
        <div class="cancel-confirmation-title">
          <span>Are you sure you want to cancel?</span>
        </div>
        <div class="cancel-confirmation-text">
          <span>
            By cancelling your
            <i>
              <b>one-time free trial</b>
            </i> you will lose all access immediately. By cancelling a paid subscription, you will retain access to our services until the next invoice date.
          </span>
        </div>
        <div class="cancel-btns">
          <div class="cancel-yes-btn" @click="confirmCancellation">
            <span>Yes</span>
          </div>
          <div class="cancel-no-btn" @click="handleNoButton">
            <span>No</span>
          </div>
        </div>
      </div>
      <div class="splash-container" v-show="pendingRequest">
        <div class="splash">
          <div class="splash-content" />
        </div>
      </div>
      <div class="payment-view" v-show="!confirmCancel && !pendingRequest">
        <div class="payment-header-wrapper">
          <span>Payment Information</span>
        </div>
        <div class="cc-info-wrapper__1" v-if="!canceled && !preventTrialLoop">
          <span class="cc-info-text__1" v-html="defaultContent"></span>
        </div>
        <div class="btn-container">
          <div
            class="cancel-sub"
            @click="handleCancelSubscriptionButton"
            v-if="!canceled && !preventTrialLoop"
          >
            <button>
              <span class="cancel-sub-text">Cancel Subscription</span>
            </button>
          </div>
        </div>

        <div class="cc-info-wrapper__3" v-if="canceled && preventTrialLoop">
          <span class="cc-info-text__3">{{ preventTrialContent }}</span>
        </div>
        <div class="prevent-btn-container">
          <div class="resub" @click="handleResubscribeButton" v-if="canceled && preventTrialLoop">
            <button>
              <span class="resub-text">Resubscribe</span>
            </button>
          </div>
          <div
            class="cancel-sub"
            @click="handleCancelSubscriptionButton"
            v-if="canceled && preventTrialLoop"
          >
            <button>
              <span class="cancel-sub-text">Cancel Subscription</span>
            </button>
          </div>
        </div>

        <div class="cc-info-wrapper__2" v-if="canceled && !preventTrialLoop">
          <span class="cc-info-text__2">{{ canceledContent }}</span>
        </div>
        <div class="cancel-btn-container">
          <div class="resub" @click="handleResubscribeButton" v-if="canceled && !preventTrialLoop">
            <button>
              <span class="resub-text">Resubscribe</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import axios from 'axios';

import db from "../../database/index";
const collection = db.collection("users");

export default {
  name: "Payment",
  props: {
    user: {
      type: Object,
    },
    discord: {
      type: Object,
    },
  },
  data() {
    return {
      confirmCancel: false,
      pendingRequest: false,
      disableButton: true,
      canceled: false,
      defaultContent:
        "Your current subscription is managed by <b>Paypal</b>. To change your payment method, please login to their site.",
      canceledContent: `Oh no, it looks like you don't have an active subscription! If you are a previous member and would like to resubscribe, click the button below. Please contact an admin if you believe this is an error.`,
      preventTrialLoop: this.user.preventTrialLoop,
      preventTrialContent: `WARNING: Duplicate trial detected, trials are limited to (1) per user. To get immediate access, cancel your subscription and resubscribe using the buttons below. Your current subscription WILL NOT automatically cancel. If you do not cancel, you will be charged at the end of your trial period.`,
    };
  },
  mounted() {
    if (this.user.status === "canceled") {
      this.canceled = true;
    }

    if (this.user.preventTrialLoop === true) {
      this.preventTrialLoop = true;
    }
  },
  methods: {
    async confirmCancellation() {

      if (this.user && this.user["type"] == "trial") {
        this.$refs["confirm-user"].show();
        return;
      }

      this.callUserPaymentCancelApi();
    },
    async confirmUserModalSubmit(e) {
      e.preventDefault();

      this.callUserPaymentCancelApi("modalClose");
    },
    async callUserPaymentCancelApi(value = null) {


      // Render splash
      this.confirmCancel = false;
      this.pendingRequest = true;

      // Paypal subscription details
      const payload = {
        paymentId: this.user.subscriptionId,
      };

      // Make subscription cancel request to Paypal API
      await axios
        .post('https://us-central1-market-moves.cloudfunctions.net/app/api/paypal/cancel', payload)
        .then(async () => {
          await collection.where('discordId', '==', this.discord.id).get()
            .then(snap => snap.forEach(async doc => {
              await collection.doc(doc.id).update({ status: 'canceled' })
          }))
          this.updateStatus();
          alert('Subscription successfully canceled.')
        })
        .catch(() => alert('Unexpected error has occured'));

      // Render subscription component
      this.status = "canceled";
      this.pendingRequest = false;

      if(value == 'modalClose') {
        this.$refs["confirm-user"].hide();
      }

    },
    handleCancelSubscriptionButton() {
      this.confirmCancel = true;
    },
    handleNoButton() {
      this.confirmCancel = false;
    },
    async fetchUserData() {
      return await collection
        .where("discordId", "==", this.discord.id)
        .get()
        .then((snap) =>
          snap.forEach((doc) => {
            this.user = doc.data();
          })
        );
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    updateStatus() {
      this.$emit("updateStatus");
    },
    handleResubscribeButton() {
      this.$router.push({ path: "/signup" });
    },
  },
};
</script>

<style scoped>
.payment-container {
  height: 240px;
  width: 400px;
  background-color: #36393f;
  color: #f8f8f8;
  border-radius: 8px;
  margin: 0 auto;
  margin-top: 20px;
  box-shadow: 1px 1px 0px #282b2f, 2px 2px 0px #2f3033, 3px 3px 0px #282b2f,
    4px 4px 0px #2f3033, 5px 5px 0px #282b2f, 6px 6px 0px #2f3033;
}

.payment-header-wrapper {
  padding-top: 20px;
  font-weight: 800;
  font-size: 1.17em;
  text-transform: uppercase;
}

.cc-info-wrapper__1 {
  margin-top: 50px;
  margin-bottom: 35px;
  padding-right: 25px;
  padding-left: 25px;
  font-size: 14px;
  text-align: justify;
}

.cc-info-wrapper__2 {
  margin-top: 25px;
  margin-bottom: 35px;
  padding-right: 25px;
  padding-left: 25px;
  font-size: 14px;
  text-align: justify;
}

.cc-info-wrapper__3 {
  margin-top: 20px;
  margin-bottom: 25px;
  padding-right: 25px;
  padding-left: 25px;
  font-size: 14px;
  text-align: justify;
}

.prevent-btn-container {
  display: flex;
  justify-content: space-evenly;
  margin-top: 12px;
}

.cc-info-text__1 {
  margin-top: 15px;
}

.cancel-sub button {
  background-color: #eb675e;
  border: #eb675e;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-size: 13px;
  padding: 6px 22px;
  text-decoration: none;
  width: 175px;
  height: 28px;
}

.cancel-sub button:hover {
  background-color: #e98f88;
  border-color: #e98f88;
}

.cancel-sub button:active {
  position: relative;
  top: 1px;
}

.cancel-sub button:focus {
  outline: 0;
}

.cancel-confirmation {
  padding-top: 30px;
}

.cancel-confirmation-title {
  padding-left: 25px;
  padding-right: 25px;
  font-size: 1.17em;
  font-weight: 800;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 10px;
}

.cancel-confirmation-text {
  margin-top: 10px;
  margin-bottom: 15px;
  padding-left: 25px;
  padding-right: 25px;
  font-size: 14px;
  text-align: justify;
}

.cancel-btns {
  display: flex;
  justify-content: space-evenly;
  margin-top: 15px;
}

.cancel-yes-btn {
  background: #eb675e;
  width: 70px;
  height: 28px;
  border-radius: 12px;
  line-height: 28px;
  margin: 0 auto;
  font-size: 14px;
}

.cancel-yes-btn:hover {
  background: #e98f88;
  border: #e98f88;
}

.cancel-no-btn {
  background: #7289da;
  width: 70px;
  height: 28px;
  border-radius: 12px;
  line-height: 28px;
  margin: 0 auto;
  font-size: 14px;
}

.cancel-no-btn:hover {
  background: #818fc0;
  border: #818fc0;
}

.resub button {
  background-color: #7289da;
  border: #7289da;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-size: 13px;
  padding: 6px 22px;
  text-decoration: none;
  width: 175px;
}

.resub button:hover {
  background-color: #818fc0;
}

.resub button:focus {
  outline: 0;
}

.splash {
  margin: 0 auto;
  padding-top: 76px;
}

.splash-content {
  width: 88px;
  height: 88px;
  margin: 0 auto;
  border: 3px solid #7289da;
  border: 3px solid transparent;
  border-top-color: #7289da;
  border-bottom-color: #7289da;
  border-radius: 50%;
  -webkit-animation: loader 2s linear infinite;
  -moz-animation: loader 2s linear infinite;
  -o-animation: loader 2s linear infinite;
  animation: loader 2s linear infinite;
}

@keyframes loader {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>